export const Portfolio = [
    {
        title: 'Design Guru',
        thumb: 'https://api.pikwy.com/web/632e9f419e34a85071222017.jpg',
        description: 'Very Simple and minimalistic landing page for design agency',
        link: 'https://collinson165.github.io/DesignGuru/',
        stack: [
            'tailwind', 'HTML', 'CSS'
        ],
        id: 1
    },
    {
        title: 'Log Travels',
        thumb: 'https://api.pikwy.com/web/632e9ecc3d785252782e67a2.jpg',
        description: 'Very Simple and minimalistic landing page for design agency',
        link: 'https://collinson165.github.io/LogTravels/',
        stack: [
            'bootstrap', 'HTML', 'CSS'
        ],
        id: 2
    },
    {
        title: 'Crappo',
        thumb: 'https://api.pikwy.com/web/632d041f5dca5136393ba5f4.jpg',
        description: 'Simple crypto landing page',
        link: 'https://collinsoncrappo.netlify.com',
        stack: [
            'tailwind', 'React', 'AOS'
        ],
        id: 3
    },
    {
        title: 'Amazing Things',
        thumb: 'https://api.pikwy.com/web/632e9fb1dbe03b647218dbb8.jpg',
        description: 'Simple crypto landing page',
        link: 'https://amazing-things.netlify.com',
        stack: [
            'tailwind', 'HTML', 'CSS'
        ],
        id: 4
    },
    {
        title: 'Design Studio',
        thumb: 'https://api.pikwy.com/web/632e9e59424d604228234bff.jpg',
        description: 'Simple crypto landing page',
        link: 'https://collinson165.github.io/Design-Studio/',
        stack: [
            'bootstrap', 'HTML', 'CSS'
        ],
        id: 5
    },
    {
        title: 'Tech Company',
        thumb: 'https://api.pikwy.com/web/632e9dd7ec0ce237384d4b22.jpg',
        description: 'Simple Tech landing page',
        link: 'https://collinson165.github.io/Tech-Company/',
        stack: [
            'bootstrap', 'HTML', 'CSS'
        ],
        id: 6
    },
    {
        title: 'Kids Sport',
        thumb: 'https://api.pikwy.com/web/632d0bce6c7d4107273d805e.jpg',
        description: 'Landing Page for a Kiddies Website',
        link: 'https://collinson165.github.io/Kids-Sport/public/',
        stack: [
            'bootstrap', 'HTML', 'CSS', 'javascript'
        ],
        id: 7
    },
    {
        title: 'Minimalist',
        thumb: 'https://api.pikwy.com/web/632d0b117c695b2cc216dc08.jpg',
        description: 'Simple and clean minimalistic landing page design',
        link: 'https://collinson165.github.io/Minimalistic/',
        stack: [
            'bootstrap', 'HTML', 'CSS', 'javascript'
        ],
        id: 8
    }
]